import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi } from 'services/api';
import type { IdBookmark, PqlBookmark, BookmarkType } from './types';

const useClearBookmarks = () => {
  const api = useApi();
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (type: BookmarkType) => {
      const records = client.getQueryData<(IdBookmark | PqlBookmark)[]>(['bookmarks', type]);

      await Promise.all((records ?? []).map((b) => api.delete(`/bookmarks/${type}/${b.id}`)));

      client.setQueryData(['bookmarks', type], []);
    },
  });
};

export { useClearBookmarks };
